import React from "react";
import { getPQRValue, getColumnClasses } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRTechniqueTable = ({ pdf, type = "Groove" }) => {
  const isOverlay = type === "Overlay";
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf,"position");

  const techniqueFields = isOverlay ? [
    { label: "Oscillation", field: "PQRD_Technique_Oscillation" },
    { label: "No. of electrodes on same puddle", field: "PQRD_Technique_ElectrodesSamePuddle" },
    { label: "Multiple or single layer", field: "PQRD_Technique_Multiple_SingleLayer" },
    { label: "Supplemental device", field: "PQRD_Technique_SupplimentalDevice" },
    { label: "Initial/interpass cleaning", field: "PQRD_Technique_InitialInterpassCleaning" },
    { label: "Overlapping", field: "PQRD_Technique_Overlaping" },
    { label: "C.T.W.D", field: "PQRD_Technique_CTWD", unit: "mm", isLast: true }
  ] : [
    { label: "String or weave", field: "PQRD_Technique_StringOrWeave" },
    { label: "Orifice/gas cup size", field: "PQRD_Technique_Orifice_GasCupSize" },
    { label: "C.T.W.D", field: "PQRD_Technique_CTWD", unit: "mm" },
    { label: "Oscillation", field: "PQRD_Technique_Oscillation" },
    { label: "Multi/Single electrode", field: "PQRD_Technique_Multi_SingleElectrode" },
    { label: "Electrode angle", field: "PQRD_Technique_ElectrodeAngle" },
    { label: "Multi/Single pass per side", field: "PQRD_Technique_SinglePassPerSide" },
    { label: "Multiple or single layer", field: "PQRD_Technique_Multiple_SingleLayer" },
    { label: "Peening", field: "PQRD_Technique_Peening" },
    { label: "Initial/interpass cleaning", field: "PQRD_Technique_InitialInterpassCleaning" },
    { label: "Back gouging method", field: "PQRD_Technique_BackGaugingMethod" },
    { label: "Groove preparation", field: "PQRD_Technique_GroovePreparation" },
    { label: "Technique Others", field: "PQRD_Technique_Technique_Other", isLast: true }
  ];

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">TECHNIQUE(QW- 410)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0" style={{borderTop:"1px solid black"}}>
          <tbody>
            {techniqueFields.map((field, index) => {
              const isFirst = index === 0;
              const className = field.isLast ? "PQRtrhide PQR_Botmrt" : "PQRtrhide PQR_right";
              
              let thClassName;
              if (field.isLast) {
                thClassName = "PQRfillerMetalth PQR_noTop";
              } else if (isFirst) {
                thClassName = "PQRfillerMetalth PQR_noBotm";
              } else {
                thClassName = "PQRfillerMetalth PQR_rt_lft";
              }

              return (
                <tr key={field.field} className={className}>
                  <th className={thClassName} style={{ width: "27%" }}>
                    {field.label}
                    {field.unit && <div className="PQRrcorner"> {field.unit} </div>}
                  </th>
                  <td className={col1Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[1]?.[field.field])}
                  </td>
                  <td className={col2Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[2]?.[field.field])}
                  </td>
                  <td className={col3Class} style={{ width: colwidth }}>
                    {getPQRValue(pdf[3]?.[field.field])}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRTechniqueTable;